<template>
  <div class="slideshow-container">
    <img v-for="number in numOfImgs" :key="number" :class="{ hide: number != slideIndex }"  class="mt-5" :src="`${publicPath}/img/${numToStrMethod(number)}.jpg`"/>
    <!-- <div class="text">Caption Text</div> -->
  </div>
</template>

<script>
export default {
  name: 'SlideShow',
  methods:{
    // Next/previous controls
    showSlides() {      
      this.slideIndex++;
      if (this.slideIndex > this.numOfImgs) {this.slideIndex = 1}
    },
    numToStrMethod(num) {
      return ("0" + num).slice(-2);
    }
  },
  data() {
    return {
      slideIndex: 1,
      numOfImgs: 41,
      publicPath: process.env.BASE_URL,
      slideshowTimer: null
    }
  },
  mounted(){
    this.slideshowTimer = setInterval(this.showSlides, 3000); // Change image every 3 seconds
  },
  beforeUnmount() {
    clearInterval(this.slideshowTimer);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {box-sizing:border-box}

/* Slideshow container */
.slideshow-container {
  /* max-width: 500px; */
  position: relative; /* Keep this */
  /* margin: auto; */
  max-width: 620px;
  margin: 0 auto;
  height: 500px;
  display: inline-block;
  vertical-align: middle;
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

img {
  width: 100%;
}

.hide {
  display: none !important;
}
</style>
